export default __webpack_public_path__ + "static/media/Icons_Hamburger.2fbc750a.svg";